/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxIcon16Light = forwardRef('ArchiveBoxIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2Zm11 4H3v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6Zm1-1V3H2v2h12Z" })));
});
